export { DiningListTemplate } from './DiningListTemplate';
export type {
  DiningListItem,
  DiningListLabels,
  DiningListTemplateProps,
  DiningMenuLink,
  DiningOpeningHours,
} from './DiningListTemplate.types';
